import { amorcApi } from 'src/tools/api';
import moment from 'moment';

export const fetchImprovements = (
  types = ['formacao', 'especializacao', 'ocupacao'],
) => amorcApi.get(`/aperfeicoamentos?tipos=${JSON.stringify(types)}`);

export const listContribuitions = (params) => amorcApi.get('/afiliacoes', {
  params,
}).then((res) => res.data);

const transformParams = (data) => {
  const params = {};

  Object.keys(data).forEach((key) => {
    if ((key === 'cus_celular_0' || key === 'cus_celular_1' || key === 'resp_celular') && data[key]) {
      params[key] = data[key].replace(/[^\d]+/g, '');
    } else if ((key === 'cus_cpf_cnpj_0' || key === 'cus_cpf_cnpj_1' || key === 'resp_cpf') && data[key]) {
      params[key] = data[key].replace(/[^\d]+/g, '');
    } else if ((key === 'resp_dat_nascimento')) {
      if (data[key]) {
        params[key] = moment(data[key], 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    } else {
      params[key] = data[key];
    }
  });

  if (params.newsletter === undefined || params.newsletter === null) {
    params.newsletter = 'N';
  }

  return params;
};

export const sendProposal = (data) => {
  const route = data.tipo_afiliacao === 'Rosacruz'
    ? '/propostas/rc'
    : '/propostas/ogg';
  const routeEnum = {
    Rosacruz: '/propostas/rc',
    TOM: '/propostas/tom',
    OGG: '/propostas/ogg',
    1: '/propostas/rc',
    6: '/propostas/tom',
    2: '/propostas/ogg',
  };

  return amorcApi.post(routeEnum[data.tipo_afiliacao], transformParams(data));
};
